import { SocialIcon } from 'react-social-icons'

import s from './SocialLinks.module.sass'

function SocialLinks({ siteSettings }: any) {
    const socialLinks = siteSettings?.socialLinks || []

    if (!socialLinks.length) return null

    return (
        <div className={s.SocialLinks}>
            {socialLinks?.map((socialLink: any) => {
                const { link, company } = socialLink

                return (
                    <div key={company} className={s.SocialLink}>
                        <SocialIcon
                            url={link}
                            fgColor="#1522B0"
                            bgColor="transparent"
                            className={s.Icon}
                            borderRadius="0"
                            target="_blank"
                            rel="noopener noreferrer"
                        />
                    </div>
                )
            })}
        </div>
    )
}

export default SocialLinks
